<template>
  <!-- footer -->
  <footer class="text-light pt-4 page-footer" style="background:#000098;">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h5 class="font-weight-bold mb-3">Le produit</h5>
          <ul class="list-unstyled ml-3">
            <li class="mb-2"><a href="#">Comment ça marche ?</a></li>
            <li class="mb-2"><a href="#">Contactez nous</a></li>
            <li class="mb-2"><a href="#">Conditions d'utilisation</a></li>
            <li class="mb-2"><a href="#">Qui sommes nous </a></li>
          </ul>
        </div>
        <div class="col-md-4">
          <h5 class="font-weight-bold mb-3">Les services</h5>
          <ul class="list-unstyled ml-3 text-uppercase">
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=docteur"
                >DOCTEUR</a
              >
            </li>
            <li class="mb-2">
              <a
                target="_blank"
                href="../services/services.php?serv=psychologue"
                >psychologue</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=mater"
                >MATERIEL MEDICAL</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=dentiste"
                >Dentiste</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=hopital"
                >HOPITAL</a
              >
            </li>
            <li class="mb-2">
              <a
                target="_blank"
                href="../services/services.php?serv=laboratoire"
                >LABORATOIRE</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=centre"
                >CENTRE D'IMAGERIE</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=clinique"
                >CLINIQUE</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=aumbulance"
                >AMBULANCE</a
              >
            </li>
            <li class="mb-2">
              <a
                target="_blank"
                href="../services/services.php?serv=veterinaires"
                >veterinaire</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=opticien"
                >opticien</a
              >
            </li>
            <li class="mb-2">
              <a target="_blank" href="../services/services.php?serv=pharmacie"
                >pharmacie</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <div class="footer-art">
            <div class="footer-header d-flex">
              <h5 class="font-weight-bold mb-3">Des articles aléatoires</h5>
              <div class="owl-btn ml-auto">
                <span class="prev"><i class="fas fa-chevron-left"></i></span>
                <span class="next"><i class="fas fa-chevron-right"></i></span>
              </div>
            </div>
            <div class="owl-articles">
              <!-- start -->
              <div v-if="articles.length > 0">
                <carousel
                  :dots="false"
                  :items="1"
                  :autoplay="true"
                  :nav="false"
                  class="mt-5 pt-3"
                >
                  <div v-for="art in articles" :key="art['.key']">
                    <div class="card text-center">
                      <div class="view overlay">
                        <img
                          class="card-img-top"
                          :src="art.image"
                          alt="miniature"
                        />
                        <a href="#!">
                          <div class="mask rgba-white-slight"></div>
                        </a>
                      </div>
                      <div class="card-body">
                        <h4 class="card-title">{{ art.titre }}</h4>
                        <p class="card-text">{{ art.resume }}</p>
                        <a href="#" class="btn btn-primary">Lire la suite</a>
                      </div>
                    </div>
                  </div>
                </carousel>
              </div>

              <!-- end -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 py-4">
          <div class="flex-center">
            <a
              href="https://www.facebook.com/dawinidz19/"
              target="_blank"
              class="fb-ic"
            >
              <i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x">
              </i>
            </a>
            <a href="https://twitter.com/dawini9" target="_blank" class="tw-ic">
              <i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x">
              </i>
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              class="inta-ic"
            >
              <i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x">
              </i>
            </a>
            <a
              href="https://www.linkedin.com/in/dawini-dz-558031186"
              target="_blank"
              class="li-ic"
            >
              <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x">
              </i>
            </a>
            <a href="https://www.youtube.com/" target="_blank" class="yb-ic">
              <i class="fab fa-youtube fa-lg white-text mr-md-5 mr-3 fa-2x">
              </i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <hr class="my-0" />
    <div class="copyrighto text-center py-2">
      <i class="fa fa-copyright" aria-hidden="true"></i> Copyright 2019 - Dawini
      dz
    </div>
  </footer>
</template>

<script>
import carousel from "vue-owl-carousel";
import { db } from "@/firebase";

export default {
  components: { carousel },
  data() {
    return {
      articles: []
    };
  },
  firebase: {
    articles: db.ref().child("articles")
  }
};
</script>